// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  IconKey,
  IconReceipt2,
  IconBug,
  IconBellRinging,
  IconPhoneCall,
} from '@tabler/icons';

// constant
const icons = {
  IconKey,
  IconReceipt2,
  IconBug,
  IconBellRinging,
  IconPhoneCall,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const accounting = {
  id: 'accounting',
  title: <FormattedMessage id='accounting' />,
  caption: <FormattedMessage id='accounting-caption' />,
  type: 'group',
  children: [
    {
      id: 'bill',
      title: <FormattedMessage id='bill' />,
      type: 'collapse',
      icon: icons.IconBug,
      children: [
        {
          id: 'purchasingBill',
          title: <FormattedMessage id='purchasingBill' />,
          type: 'item',
          url: '/app/purchase-product/list',
        },
        // {
        //   id: 'salesBill',
        //   title: <FormattedMessage id='salesBill' />,
        //   type: 'item',
        //   url: '/app/sale-bill/list',
        // },
      ],
    },
    {
      id: 'expense',
      title: <FormattedMessage id='expense' />,
      type: 'item',
      icon: icons.IconReceipt2,
      url: '/app/expense-list',
    },
    {
      id: 'salary',
      title: <FormattedMessage id='salary' />,
      type: 'collapse',
      icon: icons.IconBug,
      children: [
        {
          id: 'salaryCalculator',
          title: <FormattedMessage id='salaryCalculator' />,
          type: 'item',
          icon: icons.IconBellRinging,
          url: '/app/salary-calculator',
        },
        {
          id: 'advance',
          title: <FormattedMessage id='advance' />,
          type: 'item',
          icon: icons.IconBellRinging,
          url: '/app/advance/advance-take',
        },
      ],
    },
  ],
};

export default accounting;
